import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import ModernSelection from "../Selection2/ModernSelection";
import MagellanShow from "../CommercialComponents/commercialimagesshow/MagellanShow";
import MdrShow from "../InteriorDesignComponents/InteriorShow/mdrresidenceshow";

export default function ModernComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Modern/1.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">MDR RESIDENCE </p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization
                </span>
                <span>project duration: 2 months</span>
                <span>year of completion: 2023</span>
                <span>project location: Beylikduzu, Istanbul-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                TIMELESS ELEGANCE BLENDS WITH MODERN SOPISTICATION, CREATING A
                VILLA THAT BALANCES LUXURIOUS AESTHETICS, FUNCTIONAL DESIGN
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Modern/8.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              {/* <ParallaxImage
                src="../../Images/ResidentialImages/Modern/14.jpg"
                alt=""
              /> */}
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                TIMELESS
                <br />
                ELEGANCE
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                MEETS
                <br />
                MODERN{" "}
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                SOPHISTICATION
                <br />
              </h1>
            </div>
          </div>
        </section>

        {/* <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              Where timeless elegance blends seamlessly with modern
              sophistication, creating a villa that balances luxurious
              aesthetics, functional design, and refined artistry for an
              exceptional living experience
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="../../Images/ResidentialImages/Modern/14.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section> */}

        <section
          className="about"
          style={{
            display: "flex",
          }}
        >
          <div className="col intro">
            <p
              
            >ABOUT</p>
            <p
              style={{
                width: "70%",
                padding: "30px",
              }}
            >
              THIS PROJECT IS A RESIDENTIAL INTERIOR DESIGN CONCEPT THAT FOCUSES
              ON CREATING A MODERN AND COZY LIVING ENVIRONMENT. EACH SPACE IS
              CAREFULLY CRAFTED TO BALANCE STYLE WITH PRACTICALITY,
              INCORPORATING A VARIETY OF TEXTURES, MATERIALS, AND LIGHTING TO
              DEFINE DISTINCT ATMOSPHERES FOR DIFFERENT AREAS. THE LIVING ROOM
              FEATURES STYLISH FURNITURE WITH NEUTRAL TONES AND ACCENT COLORS,
              PAIRED WITH SOFT LIGHTING TO ENHANCE COMFORT AND SOPHISTICATION.
              THE DINING AREA OFFERS AN INVITING SPACE FOR GATHERINGS WITH A
              TOUCH OF LUXURY IN THE TABLE SETTING AND DECOR. ADDITIONAL ROOMS,
              SUCH AS THE NURSERY AND BATHROOM, ARE DESIGNED WITH PRACTICALITY
              AND WARMTH IN MIND. THE NURSERY PROVIDES A SERENE YET PLAYFUL
              AMBIANCE, WHILE THE BATHROOM SHOWCASES MODERN FIXTURES WITH AN
              ARTISTIC EDGE, BLENDING NATURAL ELEMENTS AND CREATIVE DESIGN.
         
            </p>
          </div>
          {/* <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/ResidentialImages/Modern/6.jpg"
                  alt=""
                />
              </div>
            </div>
          </div> */}
        </section>
        <div
          style={{
            padding: "50px",
          }}
        >
          <MdrShow />
        </div>

        {/* <section className="banner">
          <ModernSelection />
        </section> */}

        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Modern/42.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                A modern residential interior concept.. balanced style and
                practicality.. thoughtfully crafted spaces tailored for comfort
                and individuality..
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <InteriorDesignResidentialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
